import { useEffect, useState } from "react";
import { useGetTreatmentCodeList } from "../../hooks/useGetDataQuery";
import DemographicsCard from "./demographicsCard";
import DoctorNotes from "./doctorNotes";
import VisitInformation from "./visitInformation";
import { useTranslation } from "react-i18next";

const PatientHistory = ({ selectedPatient, t, visitNoteList, setVisitNoteList }: any) => {

  const {
    mutate: getTreatmentCodeListMutation,
    data: treatmentCodeListData,
    isSuccess: isSuccessTreatmentCodeListMutation,
  } = useGetTreatmentCodeList();

  const { i18n } = useTranslation();

  const [diagnosisOptions, setDiagnosisOptions] = useState<any>([]);

  useEffect(() => {
    getTreatmentCodeListMutation()
  }, []);


  useEffect(() => {
    if (isSuccessTreatmentCodeListMutation) {
      const treatmentCodes = treatmentCodeListData.data.map((item: any) => {
        return {
          name: i18n.language === "en" ? item.code + " --- " + item.description_en : item.code + " --- " + item.description_tr,
          value: item.code
        }
      })
      setDiagnosisOptions(treatmentCodes);
    }
  }, [isSuccessTreatmentCodeListMutation]);

  useEffect(() => {
    if (treatmentCodeListData) {
      const treatmentCodes = treatmentCodeListData.data.map((item: any) => {
        return {
          name: i18n.language === "en" ? item.code + " --- " + item.description_en : item.code + " --- " + item.description_tr,
          value: item.code
        }
      })
      setDiagnosisOptions(treatmentCodes);
    }
  }, [i18n.language]);



  return (
    <div className="flex gap-4" style={{ height: "68vh" }}>

      <DemographicsCard selectedPatient={selectedPatient} t={t} />

      <VisitInformation
        selectedPatient={selectedPatient}
        visitNoteList={visitNoteList}
        setVisitNoteList={setVisitNoteList}
        diagnosisOptions={diagnosisOptions}
        t={t} />

      <DoctorNotes selectedPatient={selectedPatient} t={t} />
    </div>
  );
};

export default PatientHistory;
